import { OnInit, Component, ViewEncapsulation } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { LoaderService } from "../services/loader.service";

@Component({
    selector: 'loader-component',
    templateUrl: './loader.component.html',
    styleUrls: ['./loader.component.scss'],
    encapsulation:ViewEncapsulation.None
})

export class LoaderComponent implements OnInit {
    public loading$;
    constructor(public dialog: MatDialog, private ls:LoaderService){

    }

    ngOnInit(): void {
        this.loading$ = this.ls.isLoading;        
    }

}